<lx-dropdown-side-panel-field
  [title]="title"
  (ngModelChange)="onSelectValue($event)"
  (blurred)="markAsTouched()"
  [(ngModel)]="selectedValue"
  data-qa="nationalitySelector"
  [options]="nationalities"
  optionLabel="name"
  optionValue="code"
  [filter]="true"
  filterBy="name"
  placeholder="Select"
>
</lx-dropdown-side-panel-field>
